<template>
  <!-- <div id="block-time-setting" v-if="config.appointment_feature == 1"> -->
  <div id="block-time-setting" v-if="config.appointment_feature == 1">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
            <router-link to="/after-login">
                <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
            </router-link>
            <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Block Time Setting</span>
        </li>
      </ul>
    </div>
    <vs-row class="mb-6 cursor-pointer" @click.native="showBusinessSetting" style="width: max-content">
      <div v-if="showBusiness == false">
        <feather-icon icon='ChevronDownIcon' svgClasses='h-6 w-6 color-black' class='mr-3'/>
      </div>
      <div v-else>
        <feather-icon icon='ChevronUpIcon' svgClasses='h-6 w-6 color-black' class='mr-3'/>
      </div>
      <h3 class="font-bold">Business Block Time</h3>
    </vs-row>
    <transition name="list">
      <div v-show="showBusiness">
        <business-block-time @LoadDataComplete="loadDataComplete"></business-block-time>
      </div>
    </transition>
    <vs-row class="mt-6 mb-6 cursor-pointer" @click.native="showStaffSetting" style="width: max-content">
      <div v-if="showStaff == false">
        <feather-icon icon='ChevronDownIcon' svgClasses='h-6 w-6 color-black' class='mr-3'/>
      </div>
      <div v-else>
        <feather-icon icon='ChevronUpIcon' svgClasses='h-6 w-6 color-black' class='mr-3'/>
      </div>
      <h3 class="font-bold">Staff Block Time</h3>
    </vs-row>
    <transition name="list">
      <div v-show="showStaff" class="rounded-item" style="width:100%; overflow: auto; box-shadow: 0 0 3px rgba(0, 0, 0, 0.05);">
        <staff-block-time></staff-block-time>
      </div>
    </transition>
  </div>
  <div v-else-if="config.appointment_feature == 0"><vx-card><h2>This is for Go Check In full version, please contact us for more info at <b>832-968-6668</b></h2></vx-card></div>
  <custom-spinner v-else></custom-spinner>
</template>
<script>
export default {
  data(){
    return{
      showBusiness: true,
      showStaff : false,
      loaded_data_num: 0,
      isOpenLoading: false
    }
  },
  watch: {
    // loaded_data_num: {
    //   immediate: true,
    //   handler() {
    //     if(this.loaded_data_num >= 1) {
    //       this.closeLoading();
    //     } else {
    //       this.openLoadingInDiv();
    //     }
    //   }
    // }
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.appointment_feature != 0 && this.config.appointment_feature != 1) {
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    showBusinessSetting(){
      if(this.showBusiness == true){
        this.showBusiness = false;
      }else{
        this.showBusiness = true;
        this.showStaff = false
      }
    },
    showStaffSetting(){
      if(this.showStaff == true){
        this.showStaff = false;
      }else{
        this.showStaff = true;
        this.showBusiness = false
      }
    },
    loadDataComplete() {
      this.loaded_data_num++;
    }
  },
  computed:{
    config() {
      return this.$store.getters["auth/config"];
    },
  },
  created(){
    if (this.config.appointment_feature != 1){
      this.loaded_data_num++;
    }
  }
}
</script>
